import React from 'react';
import { Link } from 'react-router-dom';
import { FormContainerWrapper } from 'web/components/FormContainer/formContainerStyled'

const FormContainer = ({ children }) => (
  <FormContainerWrapper>
    {children}
  </FormContainerWrapper>
);

export default FormContainer;
